module.exports = __webpack_public_path__ + "static/media/ledger.947cbd40.png";